module.exports = __webpack_public_path__ + "static/media/icons-gps.9b98257c.svg";